import { gql as r } from "@apollo/client";
const e = r`
  query GetOAuthLoginLink($oauthProviderName: String!, $redirectURI: String!) {
    getOAuthLoginLink(
      input: {
        oauthProviderName: $oauthProviderName
        redirectURI: $redirectURI
      }
    ) {
      loginURL
      state
    }
  }
`;
export {
  e as default
};
//# sourceMappingURL=getOAuthLoginLink.js.map
